import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var WorkshopIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M8.42 18.94c-.27-.16-.55-.27-.84-.37.25-.13.48-.29.69-.49.53-.53.83-1.24.83-1.99s-.3-1.47-.83-1.99c-1.06-1.06-2.92-1.06-3.98 0a2.85 2.85 0 00-.83 1.99c0 .74.29 1.46.83 1.99.2.2.44.36.69.49-.29.09-.58.21-.84.37-.65.38-1.19.92-1.57 1.58-.37.63-.57 1.34-.57 2.06 0 .55.44 1 .99 1.01.6-.01 1-.44 1.01-.99 0-.38.11-.76.29-1.1.2-.35.49-.64.84-.84.35-.2.75-.31 1.13-.32.4 0 .8.11 1.15.32.35.2.64.5.84.84.19.33.29.71.29 1.1 0 .55.45.99 1 .99h.01c.55 0 1-.46.99-1.01 0-.72-.2-1.44-.56-2.07-.37-.65-.92-1.2-1.56-1.58v.01zm-1.57-2.27c-.3.3-.85.3-1.16 0a.825.825 0 01-.24-.58c0-.22.09-.43.24-.58.15-.15.36-.24.58-.24.22 0 .43.09.58.24.15.15.24.36.24.58 0 .22-.08.42-.24.58zm14.35 3.85a4.25 4.25 0 00-1.57-1.58c-.27-.16-.55-.27-.84-.37.25-.13.48-.29.69-.49.53-.53.83-1.24.83-1.99s-.3-1.47-.83-1.99c-1.06-1.06-2.92-1.06-3.98 0a2.85 2.85 0 00-.83 1.99c0 .74.29 1.46.83 1.99.2.2.44.36.69.49-.29.09-.58.21-.84.37-.65.38-1.19.92-1.57 1.58-.35.63-.55 1.34-.55 2.06 0 .55.44 1 .99 1.01h.01a1 1 0 001-.99c0-.38.11-.76.29-1.09.2-.35.49-.64.84-.85.35-.2.75-.31 1.13-.32.4 0 .8.11 1.15.32.35.2.64.5.83.84.19.33.29.71.3 1.1 0 .55.45.99 1 .99h.01c.55 0 1-.46.99-1.01 0-.72-.2-1.43-.56-2.07l-.01.01zm-3.13-3.85a.84.84 0 01-1.16 0 .825.825 0 01-.24-.58c0-.22.09-.43.24-.58.15-.15.36-.24.58-.24.22 0 .42.08.58.24.16.16.24.36.24.58 0 .22-.08.42-.24.58zM4.26 12.83h15.23c.28 0 .56-.06.82-.16.26-.11.49-.26.7-.47.2-.2.36-.43.46-.69.11-.26.16-.54.16-.82V3.14c0-.57-.22-1.11-.63-1.51-.4-.4-.95-.63-1.52-.63H4.26c-.57 0-1.11.22-1.52.63a2.1 2.1 0 00-.62 1.51v7.54c0 1.18.96 2.14 2.14 2.14v.01zm7.61-3.14c.77 0 1.51.44 1.89 1.1 0 .01 0 .03.02.04H9.97s0-.02.01-.03c.19-.33.47-.61.8-.81.33-.19.71-.3 1.09-.3zm-.7-3.8c0-.18.07-.36.2-.49a.697.697 0 01.98 0 .697.697 0 010 .98c-.26.26-.72.26-.98 0a.697.697 0 01-.2-.49zM4.12 3.14s.02-.07.04-.1c.03-.03.06-.04.1-.04h15.23s.07.02.1.04c.03.03.04.06.04.1v7.54l-.04.1-.1.04h-3.57c-.09-.36-.23-.7-.41-1.02a4.212 4.212 0 00-2.01-1.79c.1-.07.19-.14.28-.23.51-.51.79-1.19.79-1.91s-.29-1.41-.79-1.91c-1.01-1.01-2.8-1.01-3.81 0a2.703 2.703 0 000 3.82c.09.09.19.16.28.23-.16.07-.32.15-.48.24-.63.37-1.16.9-1.53 1.55-.18.32-.32.67-.41 1.02H4.25c-.08 0-.14-.06-.14-.14V3.14h.01z"
                    })
                })
            })
        ]
    });
};
WorkshopIcon.isCarinaIcon = true;
export default WorkshopIcon;
